import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';
import WDBBSatinwood from './pages/WDBBSatinwood';
import ArtisanEvolve from './pages/ArtisanEvolve';
import MercantileBrace from './pages/MercantileBrace';
import Home from './pages/Home';
import Login from './pages/Login';
import { authService } from './services/authService';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(authService.isAuthenticated());

  useEffect(() => {
    // Подписываемся на изменения состояния авторизации
    const checkAuth = () => {
      setIsAuthenticated(authService.isAuthenticated());
    };

    // Проверяем авторизацию при изменении localStorage
    window.addEventListener('storage', checkAuth);
    
    // Создаем custom event для отслеживания изменений авторизации
    window.addEventListener('auth-change', checkAuth);

    return () => {
      window.removeEventListener('storage', checkAuth);
      window.removeEventListener('auth-change', checkAuth);
    };
  }, []);

  return (
    <Router>
      <div className="App">
        {isAuthenticated && <Navigation />}
        <div className={isAuthenticated ? "container" : ""}>
          <Routes>
            <Route path="/login" element={
              isAuthenticated ? <Navigate to="/" replace /> : <Login />
            } />
            <Route path="/" element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            } />
            <Route path="/wdbb-satinwood" element={
              <ProtectedRoute section="wdbbsatinwood">
                <WDBBSatinwood />
              </ProtectedRoute>
            } />
            <Route path="/artisan-evolve" element={
              <ProtectedRoute section="artisanevolve">
                <ArtisanEvolve />
              </ProtectedRoute>
            } />
            <Route path="/mercantile-brace" element={
              <ProtectedRoute section="mercantilebrace">
                <MercantileBrace />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;